export default __webpack_public_path__ + "static/img5-9cc898e07b748f552d61a022cfa9d893.png";